import { ssrApi } from 'api/ssr';
import { AllCollectionsPage, Props } from 'components/template/collections-all';

export default function CollectionStreamer({ collections }: Props) {
  return <AllCollectionsPage collections={collections} />;
}

import { IStreamerCollection } from 'constants/types';

export async function getServerSideProps() {
  const { results } = await ssrApi.streamerCollections.list({
    streamers_limit: 1000,
  });

  const modifiedResults = results.map((item: IStreamerCollection) => ({
    ...item,
    type: 'streamer',
  }));

  return {
    props: { collections: modifiedResults },
  };
}
